<div class="bpaas-content">
  <form [formGroup]="formGroup">
    <p-panel header="{{'label.search' | translate }}" [toggleable]="true" [collapsed]="panelCollapsed"
      expandIcon="pi pi-angle-double-up" collapseIcon="pi pi-angle-double-down">
      <div class="card" #contentElement pBPaaSFocusTrap>
        <div class="grid p-fluid">
          <div class="col-12 md:col-3 lg:col-3">
            <label [for]="parseToId('ouId')" class="bpaas-required">{{ 'field.ou' | translate }}</label>
            <p-autoComplete *ngIf="langChangeVisible" [suggestions]="ouSuggestions" [forceSelection]="true"
              [minLength]="2" [delay]="300" [showClear]="true" [showEmptyMessage]="true"
              emptyMessage="{{ 'table.no-records-found' | translate }}" (completeMethod)="searchOuSuggestions($event)"
              (onClear)="autoCompleteCleared('autoCompleteCode')" (onFocus)="autoCompleteFocus($event)"
              (onBlur)="autoCompleteBlur($event)" (onKeyUp)="autoCompleteKeyUp($event)"
              (onSelect)="autoCompleteCompleted('autoCompleteCode')" dataKey="value" appendTo="body"
              formControlName="ouId" [inputId]="parseToId('ouId')" field="label">
            </p-autoComplete>
            <div *ngIf="formControlInvalid('ouId')">
              <small class="p-error" *ngIf="formControl('ouId').errors?.['required']">
                {{ 'message.validation.required' | translate }}
              </small>
            </div>
          </div>
          <div class="col-12 md:col-3 lg:col-3">
            <label [for]="parseToId('brand')" class="bpaas-required">{{ 'field.brand' | translate }}</label>
            <p-autoComplete *ngIf="langChangeVisible" [suggestions]="brandSuggestions" [forceSelection]="true"
              [minLength]="2" [delay]="300" [showClear]="true" [showEmptyMessage]="true"
              emptyMessage="{{ 'table.no-records-found' | translate }}"
              (completeMethod)="searchBrandSuggestions($event)" (onClear)="autoCompleteCleared('autoCompleteCode')"
              (onFocus)="autoCompleteFocus($event)" (onBlur)="autoCompleteBlur($event)"
              (onKeyUp)="autoCompleteKeyUp($event)" (onSelect)="autoCompleteCompleted('autoCompleteCode')"
              dataKey="value" appendTo="body" formControlName="brand" [inputId]="parseToId('brand')" field="label">
            </p-autoComplete>
            <div *ngIf="formControlInvalid('brand')">
              <small class="p-error" *ngIf="formControl('brand').errors?.['required']">
                {{ 'message.validation.required' | translate }}
              </small>
            </div>
          </div>
          <div class="col-12 md:col-3 lg:col-3">
            <label [for]="parseToId('cust')" class="bpaas-required">{{ 'field.cust' | translate }}</label>
            <p-autoComplete *ngIf="langChangeVisible" [suggestions]="custSuggestions" [forceSelection]="true"
              [minLength]="2" [delay]="300" [showClear]="true" [showEmptyMessage]="true"
              emptyMessage="{{ 'table.no-records-found' | translate }}" (completeMethod)="searchCustSuggestions($event)"
              (onClear)="autoCompleteCleared('autoCompleteCode')" (onFocus)="autoCompleteFocus($event)"
              (onBlur)="autoCompleteBlur($event)" (onKeyUp)="autoCompleteKeyUp($event)"
              (onSelect)="autoCompleteCompleted('autoCompleteCode')" dataKey="value" appendTo="body"
              formControlName="cust" [inputId]="parseToId('cust')" field="label">
            </p-autoComplete>
            <div *ngIf="formControlInvalid('cust')">
              <small class="p-error" *ngIf="formControl('cust').errors?.['required']">
                {{ 'message.validation.required' | translate }}
              </small>
            </div>
          </div>
        </div>
        <div class="grid p-fluid">
          <div class="col-12 md:col-3 lg:col-3">
            <label [for]="parseToId('itemNumber')" class="bpaas-required">{{ 'field.item-number' | translate }}</label>
            <p-autoComplete *ngIf="langChangeVisible" [suggestions]="itemSuggestions" [forceSelection]="true"
              [minLength]="2" [delay]="300" [showClear]="true" [showEmptyMessage]="true"
              emptyMessage="{{ 'table.no-records-found' | translate }}" (completeMethod)="searchItemSuggestions($event)"
              (onClear)="onItemClear()" (onFocus)="autoCompleteFocus($event)" (onBlur)="autoCompleteBlur($event)"
              (onKeyUp)="autoCompleteKeyUp($event)" (onSelect)="onItemSelect($event)" dataKey="value" appendTo="body"
              formControlName="itemNumber" [inputId]="parseToId('itemNumber')" field="label">
            </p-autoComplete>
            <div *ngIf="formControlInvalid('itemNumber')">
              <small class="p-error" *ngIf="formControl('itemNumber').errors?.['required']">
                {{ 'message.validation.required' | translate }}
              </small>
            </div>
          </div>
          <div class="col-12 md:col-6 lg:col-6">
            <label [for]="parseToId('itemDesc')">{{ 'field.item-desc' | translate }}</label>
            <input type="text" pInputText formControlName="itemDesc" [id]="parseToId('itemDesc')" readonly />
          </div>
        </div>
        <div class="grid p-fluid">
          <div class="col-12 md:col-3 lg:col-3">
            <label [for]="parseToId('subArea')" class="bpaas-required">{{ 'field.sub-area' | translate }}</label>
            <div class="lookup-input-wrap">
              <input type="text" pInputText formControlName="subArea" [id]="parseToId('subArea')" readonly
                style="cursor:pointer;width:100%;padding-right:2rem" (click)="openSubAreaLookup()" />
              <button type="button" pButton icon="pi pi-times"
                class="p-button-secondary p-button-text lookup-clear-btn"
                [disabled]="!formControl('subArea').value"
                (click)="clearSubArea()"></button>
            </div>
            <div *ngIf="formControlInvalid('subArea')">
              <small class="p-error" *ngIf="formControl('subArea').errors?.['required']">
                {{ 'message.validation.required' | translate }}
              </small>
            </div>
          </div>
          <div class="col-12 md:col-3 lg:col-3">
            <label [for]="parseToId('endCustomer')">{{ 'field.end-customer' | translate }}</label>
            <div class="lookup-input-wrap">
              <input type="text" pInputText formControlName="endCustomer" [id]="parseToId('endCustomer')" readonly
                style="cursor:pointer;width:100%;padding-right:2rem" (click)="openEndCustomerLookup()" />
              <button type="button" pButton icon="pi pi-times"
                class="p-button-secondary p-button-text lookup-clear-btn"
                [disabled]="!formControl('endCustomer').value"
                (click)="clearEndCustomer()"></button>
            </div>
          </div>
          <div class="col-12 md:col-3 lg:col-3">
            <label [for]="parseToId('invOrg')">Inv Org</label>
            <div class="lookup-input-wrap">
              <input type="text" pInputText formControlName="invOrg" [id]="parseToId('invOrg')" readonly
                style="cursor:pointer;width:100%;padding-right:2rem" (click)="openInvOrgLookup()" />
              <button type="button" pButton icon="pi pi-times"
                class="p-button-secondary p-button-text lookup-clear-btn"
                [disabled]="!formControl('invOrg').value"
                (click)="clearInvOrg()"></button>
            </div>
          </div>
        </div>
        <div class="grid p-fluid justify-content-end bpaas-button-row">
          <div class="col-12 md:col-3 lg:col-2">
            <button type="button" pButton label="{{ 'button.reset' | translate }}" class="p-button-outlined mr-2"
              (click)="searchReset();onItemClear();" [id]="parseToId('btnReset')"></button>
          </div>
          <div class="col-12 md:col-3 lg:col-2">
            <button type="button" pButton label="{{ 'button.query' | translate }}" (click)="query()"
              [id]="parseToId('btnQuery')"></button>
          </div>
        </div>
      </div>
    </p-panel>
  </form>
</div>
<div class="bpaas-content">
  <p-panel [showHeader]="false">
    <!-- QueryId -->
    <span *ngIf="queryId">{{ 'field.query-id' | translate }} : {{queryId}}</span>

    <p-table #tableComponent [value]="detailDatas" styleClass="p-datatable-gridlines p-datatable-sm p-datatable-striped"
      [selectionMode]="tableSelectionMode" [(selection)]="rowSelectedDatas" [dataKey]="rowDataKeyName"
      [paginator]="true" [rows]="10" [showCurrentPageReport]="true"
      currentPageReportTemplate="{{ 'table.paginator' | translate: {'first': '{first}', 'last': '{last}', 'totalRecords': '{totalRecords}' } }}"
      [rowsPerPageOptions]="[10, 20, 50]" [paginatorDropdownAppendTo]="'body'" scrollHeight="75vh" [scrollable]="true"
      [resizableColumns]="true" columnResizeMode="expand" [columns]="selectedColumns"
      [detailInViewStatus]="detailInViewStatus()" (onStateSave)="onDetailTableStateSave($event)"
      (onFilter)="onDetailTableFilter($event)" (onColResize)="onColResize($event)">
      <ng-template pTemplate="header" let-columns>
        <tr id="bpaas-table-header">
          <th *ngFor="let column of columns" [pSortableColumn]="column.sortable ? column.field : ''"
            [pSortableColumnDisabled]="column.sortable ? false : true" pResizableColumn>
            <label>{{ column.header | translate }}</label>
            <p-sortIcon *ngIf="column.sortable" [field]="column.field"></p-sortIcon>
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
        <tr [id]="parseToId('rowData-' + rowIndex)">
          <td *ngFor="let column of tableColumns" [class.bpaas-align-right]="column.numberField || column.alignRight"
            [id]="parseToId('rowData-' + rowIndex + '-' + column.field)">
            <ng-container *ngIf="column.numberField">
              {{ (rowData[column.field] ?? 0) | dynamicDecimal }}
            </ng-container>
            <ng-container *ngIf="!column.numberField">
              {{ rowData[column.field] }}
            </ng-container>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td [colSpan]="tableColumns.length">
            {{ 'table.no-records-found' | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-panel>
</div>